import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";

declare var ko: any;

export class jiraTask_template extends vnTemplate{

    protected filter: filterSimple_template;

    public validationsList: validationsList_template;
    public pagination: pagination_template;
    protected appsFilter : multipleSelector_template;
    protected statusFilter : multipleSelector_template;
    public presetFilter: presetFilter_template;


    protected getTemplateHtml(): string{ 

        return `
           
            <div class="sub-header w-justify" >
                ` + this.presetFilter.getHtmlBuild() + `
                <div class="w-left" style="padding-top: 1rem;">
                       <div>` + this.appsFilter.getHtmlBuild()  +`</div>
                       <div>` + this.statusFilter.getHtmlBuild()  +`</div>
                </div>
                <div class="w-center"></div>
                <div class="w-right">
                ` + this.validationsList.getHtmlBuild()  + `
                </div>
                
            </div>
            <!-- This section is needed when multiple selection list is required. The selected filters are stored on this line -->
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-apps"></div>
                    <div id="selected-status"></div>
                </div>   
            </div>
            <div class="list-header w-justify" style="margin-top: 2rem">
                <div class="w-left">
                </div>
                <div class="w-center">` + this.filter.getHtmlBuild() + `</div>
                <div class="w-right">
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>
            

            <div class="w-list-results"  id="list-results">
                <table class="list-results">
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'keyIssue') }, css: { 'list-sort-desc': orderByAndDirection()=='keyIssue_DESC', 'list-sort-asc': orderByAndDirection()=='keyIssue_ASC' }" class="icon i-dropdown-simple">Task ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }" class="icon i-dropdown-simple">Task Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'statusName') }, css: { 'list-sort-desc': orderByAndDirection()=='statusName_DESC', 'list-sort-asc': orderByAndDirection()=='statusName_ASC' }" class="icon i-dropdown-simple">Status</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'lastStatusUpdateDate') }, css: { 'list-sort-desc': orderByAndDirection()=='lastStatusUpdateDate_DESC', 'list-sort-asc': orderByAndDirection()=='lastStatusUpdateDate_ASC' }" class="icon i-dropdown-simple">Last Status Update</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: tasks">
    
                        <tr>
                            <td><span data-bind="text: keyIssue"></span></td>
                            <td><span data-bind="text: title"></span></td>
                            <td><span data-bind="text: statusName"></span></td>
                            <td><span data-bind="text: lastStatusUpdateDate"></span></td>
                            
                        </tr>
                        
                    </tbody>
                </table>
            </div>
            `;
    }

    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('jiraTask');

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.appsFilter = new multipleSelector_template("appsFilter", this.getTemplateViewModel(), this.caller);
        this.appsFilter.setTagContainerId('selected-apps');
        this.appsFilter.setTagContainerCaption('Selected apps');
        this.appsFilter.setLabel('Apps');

        this.statusFilter = new multipleSelector_template("statusFilter", this.getTemplateViewModel(), this.caller);
        this.statusFilter.setFilterContainerClass('margin-neg');
        this.statusFilter.setTagContainerId('selected-status');
        this.statusFilter.setTagContainerCaption('Selected status:');
        this.statusFilter.setLabel('Status');

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

    }

    protected getTemplateName(): string{

        return "jiraTaskList-template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{

    	return ["w-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {    orderBy: ko.observable("")
                    ,orderByDirection: ko.observable("")
                    ,tasks: ko.observableArray([ ])
                    ,orderByAndDirection: ko.observable("")
                    ,isStatusFilterVisible: ko.observable(false)
                    ,isAppsFilterVisible: ko.observable(false)
                    ,statusFilterSelected: ko.observable([])
                    ,appsFilterSelected: ko.observable([])
                    ,onClickReorder : function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); },
                };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest(){

        return {
             orderBy: this.getTemplateViewModel().orderBy
            ,orderByDirection: this.getTemplateViewModel().orderByDirection
            ,orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            ,filter : this.getTemplateViewModel().filter
            ,statusFilter: this.getTemplateViewModel().statusFilter.selectedItems()
            ,appsFilter: this.getTemplateViewModel().appsFilter.selectedItems()
            ,pagination: this.getTemplateViewModel().pagination

        }
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)){
            if( data.orderByDirection() == "DESC" ){
                data.orderByDirection("ASC");
            }
            else{
                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.userListReorder();
    }


    public setJiraTasks(jiraTasks: Array<{taskId: string ,taskName: string ,taskStatus: string}>): void{

        this.getTemplateViewModel().tasks(jiraTasks);
    }

    public setAppsFilterItems(appFilterItems){
        
        this.appsFilter.setItems(appFilterItems);
    }

    public setStatusFilterItems(statusFilterItems, selectedItems){

        this.statusFilter.setItems(statusFilterItems);
        this.statusFilter.setSelectedItems(selectedItems.selectedItemList);
        this.statusFilter.setTags(selectedItems.selectedItemTags, statusFilterItems);
    }

    public setAppsFilterVisible(isAppsFilterVisible: boolean){

        this.getTemplateViewModel().isAppsFilterVisible(isAppsFilterVisible);
    }

    public setStatusFilterVisible(isStatusFilterVisible: boolean){

        this.getTemplateViewModel().isStatusFilterVisible(isStatusFilterVisible);
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

    /**
     * @inheritDoc
     */
    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.appsFilter, params['appsFilter']);
        this.presetFilter.setMultiSelectorPresetFilters(this.statusFilter, params['statusFilter']);
    }

    public updatePagination(totalCount){

        this.pagination.setNumberItemToPaginate(totalCount);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/jiraTask_template.ts